import React from 'react';
import { getLocale } from "@pb/utils/locale";
import { getMarket } from "@pb/utils/locale";
import { isAppDevice } from "@pb/utils/touchpoint";
import { isIos } from "@pb/utils/touchpoint";
import { isAndroid } from "@pb/utils/touchpoint";
import cn from 'classnames';
import FadeIn from "../../helpers/FadeIn";
import MessagePanel from "../../helpers/MessagePanel";
import Label from "../Label";
import CTALink from "../../ui/CTA/CTALink";
import { AppStoreIcon, GooglePlayIcon, QRAppIcon } from "../../ui/Icon";
import BodyText from "../../ui/Typography/texts/BodyText";
import styles from './PayLaterInStoreInfo.module.scss';
import { trackAppStoreClick, trackLearnMoreClick } from './tracking';
const PayLaterInStoreInfo = ({ verticalMargin, containerClassName, showAppStoreIcons = true, titleCopyKey, }) => {
    const market = getMarket('upperCase');
    const getInfo1CopyKey = () => market === 'SE'
        ? 'orderconfirmation.paylater.instore.info1.se'
        : 'orderconfirmation.paylater.instore.info1';
    return (React.createElement(FadeIn, { duration: 1000 },
        React.createElement(MessagePanel, { title: React.createElement(Label, { copyKey: titleCopyKey || 'orderconfirmation.paylater.instore.heading' }), image: React.createElement(QRAppIcon, { className: styles.qrAppImage, preserveAspectRatio: "xMidYMid slice" }), className: cn(styles.container, verticalMargin && styles[`${verticalMargin}Margin`], containerClassName) },
            React.createElement(BodyText, null,
                React.createElement(Label, { copyKey: getInfo1CopyKey() })),
            React.createElement(BodyText, null,
                React.createElement(Label, { copyKey: "orderconfirmation.paylater.instore.info2" })),
            React.createElement(CTALink, { Tag: "a", inline: true, href: `/${getLocale()}/member/hm-x-klarna.html`, onClick: trackLearnMoreClick, className: styles.learnMoreLink },
                React.createElement(Label, { copyKey: "orderconfirmation.paylater.instore.learnmore" })),
            !isAppDevice() && showAppStoreIcons && (React.createElement("div", { className: styles.appStoreContainer },
                !isIos() && ( // Should be shown for desktop + mobile devices that are not iOS
                React.createElement("a", { href: "https://play.google.com/store/apps/details?id=com.hm.goe", onClick: () => trackAppStoreClick('Google Play'), target: "_blank", rel: "noopener noreferrer", className: styles.appStoreLink },
                    React.createElement(GooglePlayIcon, { className: styles.appStoreIcon }))),
                !isAndroid() && ( // Should be shown for desktop + mobile devices that are not Android
                React.createElement("a", { href: "https://apps.apple.com/app/h-m/id834465911", onClick: () => trackAppStoreClick('App Store'), target: "_blank", rel: "noopener noreferrer", className: styles.appStoreLink },
                    React.createElement(AppStoreIcon, { className: styles.appStoreIcon }))))))));
};
export default PayLaterInStoreInfo;
//# sourceMappingURL=PayLaterInStoreInfo.js.map